<template>
  <v-dialog
    v-model="display"
    persistent
    max-width="1000"
    @click:outside="handleClose"
  >
    <v-card class="device-status-wrapper pa-0">
      <v-card-title class="pa-4 pl-11">
        <span id="history-map-title">{{ $t('device.history.event_modal.title') }}</span>
        <v-icon id="history-map-close" @click="handleClose">mdi-close</v-icon>
      </v-card-title>
      <v-divider dark />
      <v-card-text class="device-status-content-wrapper pa-12 pt-5">
        <v-row>
          <v-col>
            <v-container class="map-container">
              <l-map
                ref="history-map"
                :options="{ preferCanvas: true }"
                @ready="onMapReady"
              >
                <l-tile-layer v-bind="tilesOpts" />
              </l-map>
            </v-container>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script lang="ts">

import { Component, Prop, Vue } from 'vue-property-decorator';
import { HistoryInner } from 'ctp-history-service';
import moment from 'moment';
import L, { LatLngTuple } from 'leaflet';
import { LMap, LTileLayer } from 'vue2-leaflet';
import { MAP_ATTRIBUTION, TILES_URL } from '@/constants/map/mapConstants';

@Component({
  components: {
    LMap,
    LTileLayer
  }
})
export default class DevicesStatusUpdate extends Vue {
  @Prop()
  private enabled!: boolean;

  @Prop()
  private marker!: LatLngTuple;

  @Prop()
  private history!: HistoryInner;

  private map: L.Map;

  private tilesOpts = {
    url: TILES_URL,
    attribution: MAP_ATTRIBUTION
  };

  private get display() {
    return this.enabled;
  }

  private onMapReady() {
    const mapComponent = this.$refs['history-map'] as LMap;
    mapComponent.mapObject.invalidateSize();
    this.map = mapComponent.mapObject;
    this.map.setView(this.marker, 20);
    const defaultIcon = new L.Icon({
      // eslint-disable-next-line global-require -- Require is the only way to load a custom marker
      iconUrl: require('@/assets/images/pin.svg'),
      iconSize: [24, 36],
      iconAnchor: [12, 36]
    });
    const pin = L.marker(this.marker, { icon: defaultIcon });
    pin.bindPopup(this.genPopup(this.marker, this.history));
    pin.addTo(this.map);
  }

  private handleClose() {
    this.$emit('close', {});
  }

  private genPopup(pin: LatLngTuple, history: HistoryInner): string {
    const tooltipDOMString = `
    <div id="marker-popup">
      <span class="title">${this.$t('device.history.event')}:</span><br>
      ${this.$t('device.history.legends.category')}: ${history.category}<br>
      ${this.$t(`device.history.${history.subCategory}`)}<br>
      ${this.$t('device.history.time')}: ${moment(history.timestamp! * 1000).format('DD/MM/YYYY HH:mm:ss')}<br>
      lat: ${pin[0]}°, Lon: ${pin[1]}°<br>
      <span class="title">${this.$t('device.list.item.vehicle')}:</span><br>
      ${this.$t('device.list.item.plate_number')}: ${history.plateNumber}<br>
      ${this.$t('device.word')}: ${history.deviceId}<br>
    </div>
  `;
    return tooltipDOMString;
  }
}

</script>
<style lang="scss" scoped>
@import './history-map.scss';
</style>
